import { HeaderUserMenu } from "_metronic/partials";
import clsx from "clsx";
import { ClientPortalUserModel } from "services/api/cplauthapi/CPLAuthAPI";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "setup/redux/RootReducer";
import GlobalSearchInput from "../shared/globalSearch/GlobalSearchInput";
import { useMediaLayout } from "cpl-react-common/Hooks/useMediaQuery";
import useAsideMenu from "hooks/useAsideMenu";
import { KTSVG } from "_metronic/helpers";

const toolbarButtonMarginClass = "ms-1 ms-lg-3";

const Toolbar = () => {
  const { isMobile, isTablet, isDesktop } = useMediaLayout();
  const { asideToggled, setAsideMenuToggled } = useAsideMenu();

  const user: ClientPortalUserModel = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  ) as ClientPortalUserModel;

  const toolbarHeight = isMobile ? "50px" : "70px";

  return (
    <div className="toolbar" id="kt_toolbar" style={{ height: toolbarHeight }}>
      <div id="kt_toolbar_container" className={"d-flex flex-stack justify-content-space-between w-100"}>
        <div
          className={`aside d-flex justify-content-center align-items-center z-3 .d-md-block .d-lg-none ${
            asideToggled ? "d-none" : ""
          }`}
          style={{ width: "50px", height: "50px" }}
        >
          <div className="d-flex align-items-center me-1" title="Show aside menu">
            <div
              className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
              onClick={() => setAsideMenuToggled(!asideToggled)}
              data-test-id="navbar__show-sidebar-button"
            >
              <KTSVG
                path="/media/icons/duotune/abstract/abs015.svg"
                className="svg-icon-2x mt-1"
                color="var(--cpl-navbar-text-colour)"
              />
            </div>
          </div>
        </div>
        <div className={isMobile ? "global-search-mobile" : "global-search-desktop"}>
          <GlobalSearchInput />
        </div>
        <div className="d-flex justify-content-end flex-grow-1 pe-2">
          <div
            className={clsx("d-flex align-items-center ms-auto", toolbarButtonMarginClass)}
            id="kt_header_user_menu_toggle"
          >
            {(isDesktop || isTablet) && <div className="pl-4">{user.fullName}</div>}
            <HeaderUserMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

export { Toolbar };
